<template>
  <el-container class="warper">
    <div class="el-icon-refresh refresh" @click="refresh">
      <span>刷新</span>
    </div>
    <div class="el-icon-switch-button logout" @click="account">
      <span v-if="visit_screen">返回</span>
      <span v-if="!visit_screen">退出</span>
    </div>
    <el-header class="head noselect" id="head" ref="head">
      <MyHead />
    </el-header>
    <el-container>
      <el-main id="main" class="main" ref="main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
  import MyHead from '@/components/MyHead'
  import mapState from 'vuex'
  import $ from 'jquery'

  export default {
    name: 'layout',
    components: { MyHead },
    data() {
      return {
        visit_screen: false
      }
    },
    methods: {
      refresh() {
        window.location.reload()
      },
      // 退出当前账户
      account() {
        if (this.visit_screen) {
          this.$router.push({ path: '/Works/platformHome/Menus' })
        }
        else {
          const that = this
          this.$confirm('此操作将会退出当前账户并返回登录页, 是否继续?', '退出当前账户', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true
            setTimeout(() => {
              localStorage.removeItem('Token');
              localStorage.clear()
              that.RouteGo("Login")
            }, 1000)
          }).catch((e) => {
            // console.log(e)
          });
        }
      },
      async getauthority() {
        let userinfodata = await this.PublicApi("admin/base/getUserInfo")
        // if (userinfodata.data.top_id == 0) {
        //   this.visit_screen = true;
        // }
        if (userinfodata.data.visit_screen == 1) {
          this.visit_screen = true;
        }
        else {
          this.visit_screen = false;
        }
      }
    },
    mounted() {
      this.getauthority();
      document.getElementById('main').style.height = (document.documentElement.clientHeight - document.getElementById('head').clientHeight) + 'px';
      window.onresize = function () {
        // console.log(document.getElementById('main'))
        if (!document.getElementById('main')) return
        document.getElementById('main').style.height = (document.documentElement.clientHeight - document.getElementById('head').clientHeight) + 'px'
      }
    }
  }
</script>
<style lang="less">
  @import url("../assets/css/element.css");
  @import url("../assets/css/common.less");
  @import url("../assets/css/main.less");
</style>



// WEBPACK FOOTER //
// src/layout/index.vue